module.exports = __webpack_public_path__ + "img/bank-agi.6be97901.png";